import DashboardPage from "../UserPages/DashboardPage";
import UsersPage from "../UserPages/UsersPage";
import QuerysPage from "../UserPages/QuerysPage";
import BugsReportPage from "../UserPages/BugsReportPage";
import ProfilePage from "../UserPages/ProfilePage";
import SupportPage from "../UserPages/SupportPage";
import ServicesLeadsPage from "../UserPages/ServicesLeadsPage";

export const RouterItems = [
  {
    link: "/dashboard",
    name: "Dashboard",
    page: <DashboardPage />,
  },
  {
    link: "/users",
    name: "Users",
    page: <UsersPage />,
  },
  {
    link: "/service-leads",
    name: "Service Leads",
    page: <ServicesLeadsPage/>
  },
  {
    link: "/queries",
    name: "Queries",
    page: <QuerysPage />,
  },
  {
    link: "/bugs-report",
    name: "Bugs Report",
    page: <BugsReportPage />,
  },
  {
    link: "/myprofile",
    name: "My Profile",
    page: <ProfilePage />,
  },
  {
    link: "/support",
    name: "Support",
    page: <SupportPage />,
  },
];
